import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useCallback, useState } from "react";
function useRerender() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    setSignal = _useState2[1];
  var rerender = useCallback(function () {
    setSignal({});
  }, []);
  return rerender;
}
export default useRerender;